document.addEventListener('DOMContentLoaded', () => {
    let lastScrollY = window.scrollY;
    let ticking = false;
    let isScrollingDown = false;
    // Get the page slug from <body class="page-slug-...">
    const body = document.body;
    const slugClass = Array.from(body.classList).find(cls =>
        cls.startsWith('page-slug-')
    );
    const pageSlug = slugClass ? slugClass.replace('page-slug-', '') : null;

    const pairs = [
        {
            trigger: '.student-submenu-trigger',
            submenu: '.localads-submenu.students-submenu',
            name: 'students'
        },
        {
            trigger: '.business-submenu-trigger',
            submenu: '.localads-submenu.business-submenu',
            name: 'business'
        }
    ];

    pairs.forEach(pair => {
        const trigger = document.querySelector(pair.trigger);
        const submenu = document.querySelector(pair.submenu);

        if (!submenu) return;

        // Get submenu-inner (the clickable header area)
        const submenuInner = submenu.querySelector('.submenu-inner');

        // --- Desktop hover logic ---
        let submenuTimer = null;
        function showSubmenu() {
            const headerHeight = document.querySelector('.localads-header-top')?.offsetHeight || 118;
            submenu.style.top = `${headerHeight}px`;
            submenu.classList.remove('fade-out');
            submenu.classList.add('is-hovered');
            if (submenuTimer) {
                clearTimeout(submenuTimer);
                submenuTimer = null;
            }
        }
        function hideSubmenu() {
            submenuTimer = setTimeout(() => {
                submenu.classList.add('fade-out');
                setTimeout(() => {
                    submenu.classList.remove('is-hovered');
                    submenu.classList.remove('fade-out');
                }, 150);
            }, 500);
        }
        function enableDesktopEvents() {
            if (trigger) {
                trigger.addEventListener('mouseenter', showSubmenu);
                trigger.addEventListener('focus', showSubmenu);
                trigger.addEventListener('mouseleave', hideSubmenu);
                trigger.addEventListener('blur', hideSubmenu);
            }
            submenu.addEventListener('mouseenter', showSubmenu);
            submenu.addEventListener('mouseleave', hideSubmenu);
        }
        function disableDesktopEvents() {
            if (trigger) {
                trigger.removeEventListener('mouseenter', showSubmenu);
                trigger.removeEventListener('focus', showSubmenu);
                trigger.removeEventListener('mouseleave', hideSubmenu);
                trigger.removeEventListener('blur', hideSubmenu);
            }
            submenu.removeEventListener('mouseenter', showSubmenu);
            submenu.removeEventListener('mouseleave', hideSubmenu);
            submenu.classList.remove('is-hovered');
        }

        // --- Mobile dropdown logic ---
        let mobileActive = false;

        function openDropdown() {
            submenu.classList.add('open');
            const toggleBtn = submenuInner.querySelector('.submenu-toggle');
            if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
        }
        function closeDropdown() {
            submenu.classList.remove('open');
            const toggleBtn = submenuInner.querySelector('.submenu-toggle');
            if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
        }
        function toggleDropdown(e) {
            // Don't toggle if the click is inside .submenu-right (the dropdown area itself)
            if (e.target.closest('.submenu-right')) return;
            e.preventDefault();
            if (submenu.classList.contains('open')) {
                closeDropdown();
            } else {
                openDropdown();
            }
        }
        function outsideClick(e) {
            if (window.innerWidth > 800) return;
            // Close dropdown if click is outside submenu
            if (!submenu.contains(e.target)) {
                closeDropdown();
            }
        }

        function enableMobileDropdown() {
            if (mobileActive) return;
            if (submenuInner) submenuInner.addEventListener('click', toggleDropdown);
            document.addEventListener('click', outsideClick);
            mobileActive = true;
        }
        function disableMobileDropdown() {
            if (!mobileActive) return;
            if (submenuInner) submenuInner.removeEventListener('click', toggleDropdown);
            document.removeEventListener('click', outsideClick);
            closeDropdown();
            mobileActive = false;
        }

        // --- Responsive switching ---
        function handleResize() {
            if (window.innerWidth > 800) {
                enableDesktopEvents();
                disableMobileDropdown();
            } else {
                disableDesktopEvents();
                enableMobileDropdown();
            }
        }
        window.addEventListener('resize', handleResize);
        handleResize();

        // Handle scroll for submenu positioning
        window.addEventListener('scroll', () => {
            if (submenu.classList.contains('is-hovered') || submenu.classList.contains('is-active')) {
                const headerHeight = document.querySelector('.localads-header-top')?.offsetHeight || 118;
                submenu.style.top = `${headerHeight}px`;
            }
        });


    });
});
